import { theme } from "../../utils/theme";

export const Theme = () => {
  return (
    <div>
      <div className="flex justify-evenly">
        <div>
          <p className="font-poppins font-thin text-4xl">Poppins - font-thin</p>
          <p className="font-poppins font-extralight text-4xl">
            Poppins - font-extralight
          </p>
          <p className="font-poppins font-light text-4xl">
            Poppins - font-light
          </p>
          <p className="font-poppins font-normal text-4xl">
            Poppins - font-normal
          </p>
          <p className="font-poppins font-medium text-4xl">
            Poppins - font-medium
          </p>
          <p className="font-poppins font-semibold text-4xl">
            Poppins - font-semibold
          </p>
          <p className="font-poppins font-bold text-4xl">Poppins - font-bold</p>
          <p className="font-poppins font-extrabold text-4xl">
            Poppins - font-extrabold
          </p>
          <p className="font-poppins font-black text-4xl">
            Poppins - font-black
          </p>
        </div>
        <div>
          <p className="font-nunito font-thin text-4xl">Nunito - font-thin</p>
          <p className="font-nunito font-extralight text-4xl">
            Nunito - font-extralight
          </p>
          <p className="font-nunito font-light text-4xl">Nunito - font-light</p>
          <p className="font-nunito font-normal text-4xl">
            Nunito - font-normal
          </p>
          <p className="font-nunito font-medium text-4xl">
            Nunito - font-medium
          </p>
          <p className="font-nunito font-semibold text-4xl">
            Nunito - font-semibold
          </p>
          <p className="font-nunito font-bold text-4xl">Nunito - font-bold</p>
          <p className="font-nunito font-extrabold text-4xl">
            Nunito - font-extrabold
          </p>
          <p className="font-nunito font-black text-4xl">Nunito - font-black</p>
        </div>

        <div>
          <p className="font-trirong font-thin text-4xl">trirong - font-thin</p>
          <p className="font-trirong font-extralight text-4xl">
            trirong - font-extralight
          </p>
          <p className="font-trirong font-light text-4xl">
            trirong - font-light
          </p>
          <p className="font-trirong font-normal text-4xl">
            trirong - font-normal
          </p>
          <p className="font-trirong font-medium text-4xl">
            trirong - font-medium
          </p>
          <p className="font-trirong font-semibold text-4xl">
            trirong - font-semibold
          </p>
          <p className="font-trirong font-bold text-4xl">trirong - font-bold</p>
          <p className="font-trirong font-extrabold text-4xl">
            trirong - font-extrabold
          </p>
          <p className="font-trirong font-black text-4xl">
            trirong - font-black
          </p>
        </div>
      </div>

      <div className="min-h-10 bg-slate-10">
        <p>slate10: {theme.colors.slate[10]}</p>
      </div>
      <div className="min-h-10 bg-slate-50">
        <p>slate-50: {theme.colors.slate[50]}</p>
      </div>
      <div className="min-h-10 bg-slate-100">
        <p>slate-100: {theme.colors.slate[100]}</p>
      </div>
      <div className="min-h-10 bg-slate-200">
        <p>slate-200: {theme.colors.slate[200]}</p>
      </div>
      <div className="min-h-10 bg-slate-300">
        <p>slate-300: {theme.colors.slate[300]}</p>
      </div>
      <div className="min-h-10 bg-slate-400">
        <p>slate-400: {theme.colors.slate[400]}</p>
      </div>
      <div className="min-h-10 bg-slate-500">
        <p>slate-500: {theme.colors.slate[500]}</p>
      </div>
      <div className="min-h-10 bg-slate-600">
        <p>slate-600: {theme.colors.slate[600]}</p>
      </div>
      <div className="min-h-10 bg-slate-700">
        <p>slate-700: {theme.colors.slate[700]}</p>
      </div>
      <div className="min-h-10 bg-slate-800">
        <p>slate-800: {theme.colors.slate[800]}</p>
      </div>
      <div className="min-h-10 bg-slate-900">
        <p>slate-900: {theme.colors.rust[900]}</p>
      </div>

      <div className="min-h-10 bg-rust-10">
        <p>rust-10: {theme.colors.rust[10]}</p>
      </div>
      <div className="min-h-10 bg-rust-50">
        <p>rust-50: {theme.colors.rust[50]}</p>
      </div>
      <div className="min-h-10 bg-rust-100">
        <p>rust-100: {theme.colors.rust[100]}</p>
      </div>
      <div className="min-h-10 bg-rust-200">
        <p>rust-200: {theme.colors.rust[200]}</p>
      </div>
      <div className="min-h-10 bg-rust-300">
        <p>rust-300: {theme.colors.rust[300]}</p>
      </div>
      <div className="min-h-10 bg-rust-400">
        <p>rust-400: {theme.colors.rust[400]}</p>
      </div>
      <div className="min-h-10 bg-rust-500">
        <p>rust-500: {theme.colors.rust[500]}</p>
      </div>
      <div className="min-h-10 bg-rust-600">
        <p>rust-600: {theme.colors.rust[600]}</p>
      </div>
      <div className="min-h-10 bg-rust-700">
        <p>rust-700: {theme.colors.rust[700]}</p>
      </div>
      <div className="min-h-10 bg-rust-800">
        <p>rust-800: {theme.colors.rust[800]}</p>
      </div>
      <div className="min-h-10 bg-rust-900">
        <p>rust-900: {theme.colors.rust[900]}</p>
      </div>

      <div className="min-h-10 bg-delicate-10">
        <p>delic1te-10: {theme.colors.delicate[10]}</p>
      </div>
      <div className="min-h-10 bg-delicate-50">
        <p>delicate-50: {theme.colors.delicate[50]}</p>
      </div>
      <div className="min-h-10 bg-delicate-100">
        <p>delicate-100: {theme.colors.delicate[100]}</p>
      </div>
      <div className="min-h-10 bg-delicate-200">
        <p>delicate-200: {theme.colors.delicate[200]}</p>
      </div>
      <div className="min-h-10 bg-delicate-300">
        <p>delicate-300: {theme.colors.delicate[300]}</p>
      </div>
      <div className="min-h-10 bg-delicate-400">
        <p>delicate-400: {theme.colors.delicate[400]}</p>
      </div>
      <div className="min-h-10 bg-delicate-500">
        <p>delicate-500: {theme.colors.delicate[500]}</p>
      </div>
      <div className="min-h-10 bg-delicate-600">
        <p>delicate-600: {theme.colors.delicate[600]}</p>
      </div>
      <div className="min-h-10 bg-delicate-700">
        <p>delicate-700: {theme.colors.delicate[700]}</p>
      </div>
      <div className="min-h-10 bg-delicate-800">
        <p>delicate-800: {theme.colors.delicate[800]}</p>
      </div>
      <div className="min-h-10 bg-delicate-900">
        <p>delicate-900: {theme.colors.delicate[900]}</p>
      </div>

      <div className="min-h-10 bg-sand-10">
        <p>sand-10: {theme.colors.sand[10]}</p>
      </div>
      <div className="min-h-10 bg-sand-50">
        <p>sand-50: {theme.colors.sand[50]}</p>
      </div>
      <div className="min-h-10 bg-sand-100">
        <p>sand-100: {theme.colors.sand[100]}</p>
      </div>
      <div className="min-h-10 bg-sand-200">
        <p>sand-200: {theme.colors.sand[200]}</p>
      </div>
      <div className="min-h-10 bg-sand-300">
        <p>sand-300: {theme.colors.sand[300]}</p>
      </div>
      <div className="min-h-10 bg-sand-400">
        <p>sand-400: {theme.colors.sand[400]}</p>
      </div>
      <div className="min-h-10 bg-sand-500">
        <p>sand-500: {theme.colors.sand[500]}</p>
      </div>
      <div className="min-h-10 bg-sand-600">
        <p>sand-600: {theme.colors.sand[600]}</p>
      </div>
      <div className="min-h-10 bg-sand-700">
        <p>sand-700: {theme.colors.sand[700]}</p>
      </div>
      <div className="min-h-10 bg-sand-800">
        <p>sand-800: {theme.colors.sand[800]}</p>
      </div>
      <div className="min-h-10 bg-sand-900">
        <p>sand-900: {theme.colors.sand[900]}</p>
      </div>

      <div className="min-h-10 bg-herb-10">
        <p>herb-10: {theme.colors.herb[10]}</p>
      </div>
      <div className="min-h-10 bg-herb-50">
        <p>herb-50: {theme.colors.herb[50]}</p>
      </div>
      <div className="min-h-10 bg-herb-100">
        <p>herb-100: {theme.colors.herb[100]}</p>
      </div>
      <div className="min-h-10 bg-herb-200">
        <p>herb-200: {theme.colors.herb[200]}</p>
      </div>
      <div className="min-h-10 bg-herb-300">
        <p>herb-300: {theme.colors.herb[300]}</p>
      </div>
      <div className="min-h-10 bg-herb-400">
        <p>herb-400: {theme.colors.herb[400]}</p>
      </div>
      <div className="min-h-10 bg-herb-500">
        <p>herb-500: {theme.colors.herb[500]}</p>
      </div>
      <div className="min-h-10 bg-herb-600">
        <p>herb-600: {theme.colors.herb[600]}</p>
      </div>
      <div className="min-h-10 bg-herb-700">
        <p>herb-700: {theme.colors.herb[700]}</p>
      </div>
      <div className="min-h-10 bg-herb-800">
        <p>herb-800: {theme.colors.herb[800]}</p>
      </div>
      <div className="min-h-10 bg-herb-900">
        <p>herb-900: {theme.colors.herb[900]}</p>
      </div>
    </div>
  );
};
